module.exports = __webpack_public_path__ + "img/mall.809e80dc.png";